import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';
import { useTranslation } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

export interface IRecordingPlaceholderPresenter {
  title: string;
  ongoingCall: Call;
  showDialog(): void;
  onStopRecording(): Promise<void>;
}

export const useRecordingPlaceholderPresenter = (): IRecordingPlaceholderPresenter => {
  const { t } = useTranslation();
  const context = useCallContext();

  const presenter = useLocalObservable<IRecordingPlaceholderPresenter>(() => ({
    get title(): string {
      return t('call_recording_rec_hint');
    },

    get ongoingCall(): Call {
      return context.call;
    },

    showDialog(): void {
      const canStopRecording = presenter.ongoingCall.canStopRecording;

      if (canStopRecording) {
        this.onStopRecording();
      } else {
        popupsTasks.showAlert(t('calls_recording_recording_alert'));
      }
    },

    async onStopRecording(): Promise<void> {
      const canStop = await popupsTasks.showConfirm({
        text: t('calls_recording_stop_alert'),
        primaryText: t('common_stop'),
      });

      if (canStop) {
        await context.callController.stopRecording();
      }
    },
  }));

  return presenter;
};
